<template lang="pug">
	
	.scroll-indicator
		.indicator
			p {{translate('globals.scroll')}}
			img(src="assets/images/scroll-icon.png")


</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../utils/scroller.js'
	import Ticker from '../utils/ticker.js'
	import Section from '../abstracts/section'
	
  @Component({
		name: 'Header',
		components: {  }
	})

	class Header extends Vue {

		mounted () {

			this.$events.on('scroll.in',this.show.bind(this))
			this.$events.on('scroll.out',this.hide.bind(this))
			this.hide(0.1)
		}
		

		
		init () {
			

		}

		show () {
			TweenMax.to(this.$el,1,{opacity:1})
		}

		hide (duration = .6) {
			TweenMax.to(this.$el,duration,{opacity:0})
		}

		_resize () {
		}	

	}

	export default Header

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.scroll-indicator
		position fixed
		bottom 0
		left 0
		width 100vw
		z-index 90
		overflow hidden
		display flex
		justify-content center
		opacity 0

		.indicator

			text-align center
			margin-bottom 60px
			opacity .5

			p
				font-size 12px
				font-family $FONT_SECONDARY
				font-weight 300
				color #fff
				text-transform uppercase
				margin-bottom 24px
				letter-spacing .15em
				


</style>


// WEBPACK FOOTER //
// scroll-indicator.vue?e4ab2f06